module.exports = __webpack_public_path__ + "img/2.0a22c2a5.png";